// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import 'swiper/dist/css/swiper.min.css';
// import 'swiper/dist/js/swiper.min.js';
// import animated from 'animate.css'
import axios from "./utils/axios";
import "../static/css/global.css";
// handoff 设计体系（website-handoff/css/style.css 移植，保持与交付包一致）
import "./styles/site.css";
// 项目自定义适配层（导航搜索框、旧站遮罩、登录弹窗补充结构等）
import "./styles/app.css";
import store from "./store/store";
import { API_BASE_URL } from "./config";
// 路由级 SEO：切换路由时同步 title / description / canonical / OG / JSON-LD
import { installSeo } from "./utils/seo";
// import VueLazyload from 'vue-lazyload'
import VueRouter from "vue-router";
import Cookies from "js-cookie";
Vue.use(VueRouter);
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   // error: require('@/img/case1.png'),   //请求失败后显示的图片
//   // loading: require('@/img/case1.png'),   //加载的loading过渡图片
//   attempt: 1     // 加载图片数量
// })
Vue.prototype.$axios = axios;
Vue.use(ElementUI);
// Vue.use(animated)
Vue.prototype.$cookies = Cookies;
Vue.prototype.$phone = function(phone) {
  if (!phone || phone.toString().length < 11) return phone;
  return phone.substr(0, 3) + "****" + phone.substring(7);
};

let tim = new Date().getTime();

/* 接口地址：统一由环境变量 VUE_APP_API_BASE_URL 提供（见项目根目录 .env / .env.development / .env.production）。
   本地开发与线上默认都指向正式环境；
   原内网调试地址 http://192.168.0.18:8020/ 已不可达，故移除该分支（经确认的改动）。
   如需切回内网后端联调，在 .env.development 里覆盖 VUE_APP_API_BASE_URL 即可，无需改代码。 */
Vue.prototype.host_url = API_BASE_URL;
// 在首个路由确认前装好 head 管理，保证首屏 meta 与当前路由一致
installSeo(router);
router.afterEach((to, from) => {
  let this_time = new Date().getTime();
  if (this_time - tim > 14400000) {
    window.location.reload();
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});
// 路由守卫
// router.beforeEach((to, from, next) => {
//   // var token = sessionStorage.getItem('token');
//   // // 判断路由组件中的某个属性
//   // if (to.meta.requiresAuth === true) {
//   //   if (token) {
//   //     return next();
//   //   } else {
//   //     return next({name: 'login'});
//   //   }
//   // }

//   // if (to.meta.requiresGuest === true) {
//   //   if (token) {
//   //     return next({name: 'business'});
//   //   } else {
//   //     return next();
//   //   }
//   // }
//   console.log(to,from)
//   next();
// });



// WEBPACK FOOTER //
// ./src/main.js